export const RequiredValidatorKey = 'required';
export const EmailValidatorKey = 'email';
export const MaxLengthValidatorKey = 'maxlength';
export const MinLengthValidatorKey = 'minlength';
export const MinValidatorKey = 'min';
export const MaxValidatorKey = 'max';